<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11pW6gY/tc-custom/9781459222212.jpg?1743862932437" alt="This image is the cover for the book Healing Hearts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Healing Hearts
      </h1>
      <p class="bookDescription body article font2">
        <p>Fun-loving schoolteacher Tessa Stanridge needed a way to stay in Hill Creekfast! Suddenly, like a gift from God, a white knight in the form of accident victim Drake Slater came to her rescue. The moment she saw the handsome rancher, she knew he was a man desperately in need of her loving carejust as she knew her life would never be the same.<br/><br/>Drake was out to prove he was every bit the same rugged loner he had been before his accident. Trouble was, with Tessa around, even that wouldn't be enough. Now, it wasn't just that he wanted to learn to walk againTessa was the kind of woman who made a man want to be better than he was. And for this man, Tessa was turning out to be the best medicine of all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cheryl Wolverton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?94b9fc42